// extracted by mini-css-extract-plugin
export var center = "_50-2";
export var clickableRow = "_50-5";
export var expandedRow = "_50-7";
export var hoverable = "_50-4";
export var left = "_50-1";
export var right = "_50-3";
export var row = "_50-0";
export var selectedRow = "_50-6";
export var summaryRow = "_50-8";